module.exports = __webpack_public_path__ + "img/cloud-inprogress.a391f10c.svg";